<template>
    <div class="d-flex align-items-center">
        <b-button
            title="Delete"
            variant="outline-primary"
            @click="$bvModal.show(deleteGuestModalId)"
            :disabled="!reservationEdit"
        >
            <busy-modal :show="loading"></busy-modal>
            <font-awesome-icon :icon="['fas', 'xmark']" />
        </b-button>
        <modal :id="deleteGuestModalId" title="Delete Guest" @ok="deleteGuest">
            <p>Are you sure you want to delete this guest?</p>
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import Modal from '../../../../generic/modal/modal.vue';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import { formatResponseError } from '../../../../../utils/api';
import { GUEST_GUEST_NAMES_BY_ID_ENDPOINT } from '../../../../../endpoints.js';

export default {
    components: { Modal, BusyModal },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
    },
    data() {
        return { deleteGuestModalId: '', loading: false };
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    created() {
        this.deleteGuestModalId = `delete-guest-modal-id-${this.params.data.id}`;
    },
    methods: {
        async deleteGuest() {
            this.loading = true;
            try {
                await API.delete(GUEST_GUEST_NAMES_BY_ID_ENDPOINT(this.params.data.id));
                this.params.refreshReservation(() => this.showSuccessToast({ text: `Guest successfully deleted.` }));
            } catch (err) {
                const { generic } = formatResponseError(err);
                this.showErrorToast({ text: generic || `Could not delete guest.` });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.btn) {
    min-width: 2.7rem !important;
}
</style>
